/** The methods listed below are global methods available 
 *  under Vue.$date.methodName(), e.g. this.$date.getToday()
 */

import moment from "moment";
import helpers from "./helpers.js";

export default {
    getToday(){
        return moment().startOf('day');
    },
    getTomorrow(){
        let today = this.getToday();
        return moment(today).add(1, 'd').startOf('day');
    },
    getFirstTravelDate(){
        let today = this.getToday();
        let minDaysOut = 0;
        return moment(today).add(minDaysOut, 'd').startOf('day');
    },
    getSecondTravelDate(){
        let firstTravelDate = this.getFirstTravelDate();
        return moment(firstTravelDate).add(1, 'd').startOf('day');
    },
    getLastTravelDate(){
        let today = this.getToday();
        let maxDaysOut = 340;
        return moment(today).add(maxDaysOut, 'd').startOf('day');
    },
    dateToString(date) {
        return ( date.getFullYear() + '-' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))) + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()));
    },
    timeToString(date) {
        return helpers.doubleZero(date.getHours()) + ":" + helpers.doubleZero(date.getMinutes());
    },
    compareDate(date) {
        let today = new Date()
        return date.compare(date, today) !== -1
    },
    convertTime(time) {
        // Check correct time format and split into components
        time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) { // If time format correct
            time = time.slice (1);  // Remove full string match value
            time[5] = +time[0] < 12 ? 'am' : 'pm'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join (''); // return adjusted time or original string
    },
    dobValidate(dob) {

        var dobIsValid = true;
        var maxAge = 100;
        var minAge = 13;

        if(!dob){
            dobIsValid = false;
        }

        var today = new Date();
        var nowyear = today.getFullYear();
        var nowmonth = today.getMonth();
        var nowday = today.getDate();

        var birth = new Date(dob);

        var birthyear = birth.getFullYear();
        var birthmonth = birth.getMonth();
        var birthday = birth.getDate();

        var age = nowyear - birthyear;
        var age_month = nowmonth - birthmonth;
        var age_day = nowday - birthday;

        if (age > maxAge || age < minAge) {
            console.error(`Age cannot be more than ${maxAge} and less than ${minAge} years. Please enter correct age.`);
            dobIsValid = false;
        }

        // console.log('called this.$date.dobValidate() from PLUGIN BEFORE RETURN', dob, dobIsValid);
        return dobIsValid;
    },
}